import React from 'react';
import slug from 'constants/slug';
import {
  Button,
  Card,
  Elevation,
  InputGroup,
  Intent,
  Hotkey,
  Hotkeys,
  HotkeysTarget,
} from '@blueprintjs/core';
import styled from 'styled-components';
import { createForm } from 'rc-form';
import { login } from 'api/auth';
import Message from 'rc-message';
import { connect } from 'react-redux';
import { logged } from '@redux/actions/authAction';
import { get as _get } from 'lodash';

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f5f6fa;
`;
const Brand = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  margin-bottom: 35px;

  img {
    height: 100%;
  }
`;
const HeaderContainer = styled.div`
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  font-size: 28px;
  margin-bottom: 0px;
  font-weight: 600;
`;

const Label = styled.label`
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  font-weight: 600;
`;

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

@connect(
  (state) => ({
    isLogged: _get(state, 'auth.isLogged', false),
  }),
  {
    logged,
  }
)
@createForm()
@HotkeysTarget
export default class Login extends React.Component {
  state = {
    isSubmitting: false,
  };

  renderHotkeys() {
    return (
      <Hotkeys>
        <Hotkey
          //global={true}
          allowInInput={true}
          combo='enter'
          label='Be awesome all the time'
          onKeyDown={this.submit}
        />
      </Hotkeys>
    );
  }

  submit = () => {
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    this.props.form.validateFields((error, value) => {
      if (error) {
        this.setState({ isSubmitting: false });
        return;
      }
      // console.log(value);
      this.login(value);
    });
  };

  login = async (data) => {
    const res = await login(data);
    if (res.error) Message.error({ content: res.message });
    if (res.success) {
      this.props.logged(res.token, res.data);
      this.props.history.push(slug.CO_SO.LIST);
    }
    this.setState({ isSubmitting: false });
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <Container>
        <Brand>
          <img src='/ilotusland-logo-with-text.svg' alt='ilotusland' />
        </Brand>
        <Card
          interactive={true}
          elevation={Elevation.TWO}
          style={{
            width: 450,
            padding: '24px 32px',
          }}
        >
          <HeaderContainer>
            <div style={{ padding: '16px 0px' }}>Login</div>
          </HeaderContainer>
          <div>
            <Label className='bp3-label'>
              Username
              <InputGroup
                fill
                type='text'
                placeholder='UserName'
                dir='auto'
                {...getFieldProps('UserName', {
                  initialValue: '',
                  rules: [
                    {
                      required: true,
                    },
                  ],
                })}
              />
              <ErrorContainer>
                {(getFieldError('UserName') || []).join(', ')}
              </ErrorContainer>
            </Label>
          </div>
          <div>
            <Label className='bp3-label'>
              Password
              <InputGroup
                fill
                type='Password'
                placeholder='******'
                dir='auto'
                {...getFieldProps('Password', {
                  initialValue: '',
                  rules: [
                    {
                      required: true,
                    },
                  ],
                })}
              />
              <ErrorContainer>
                {(getFieldError('Password') || []).join(', ')}
              </ErrorContainer>
            </Label>
          </div>
          <Button
            loading={this.state.isSubmitting}
            fill
            intent={Intent.SUCCESS}
            onClick={this.submit}
            style={{ backgroundColor: '#1890FF', color: '#FFFFFF' }}
          >
            Login
          </Button>
        </Card>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/LoginContainer/index.js